import { useEffect, useRef, useState } from "react";
import { getTrialBalanceData } from "../../../../Utility/Api";
import "bootstrap/dist/css/bootstrap.min.css";
import { currentMonth, handlePrint, NaviGate } from "../../../../Utility/function";
import TrialBalance from "../acc/TrialBalance";

const CompanyReport = () => {
  const contentRef = useRef(null);
  const [filterType, setFilterType] = useState("month");
  const [selectedMonth, setSelectedMonth] = useState(currentMonth());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());
  const [customFromDate, setCustomFromDate] = useState("");
  const [customToDate, setCustomToDate] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [trialData, setTrialData] = useState([]);

  useEffect(() => {
    updateDateRange();
  }, [filterType, selectedMonth, selectedYear, customFromDate, customToDate]);

  useEffect(() => {
    if (fromDate && toDate) {
      onReqTrialData();
    }
  }, [fromDate, toDate]);

  const updateDateRange = () => {
    let startDate = "";
    let endDate = "";

    if (filterType === "month") {
      startDate = `${selectedMonth}-01`;
      const lastDay = new Date(
        new Date(startDate).getFullYear(),
        new Date(startDate).getMonth() + 1,
        0
      ).getDate();
      endDate = `${selectedMonth}-${lastDay}`;
    } else if (filterType === "year") {
      startDate = `${selectedYear}-01-01`;
      endDate = `${selectedYear}-12-31`;
    } else if (filterType === "custom") {
      startDate = customFromDate;
      endDate = customToDate;
    }

    setFromDate(startDate);
    setToDate(endDate);
  };

  const onReqTrialData = async () => {
    try {
      const params = {
        start_date: fromDate,
        end_date: toDate
      };
      const res = await getTrialBalanceData(params);
      setTrialData(res.data.grouped_data || []);
    } catch (error) {
      console.error(error);
    }
  };

  const renderFilterControls = () => {
    switch (filterType) {
      case "month":
        return (
          <div className="col-md-4 me-1">
            <div className="form-floating">
              <input
                type="month"
                className="form-control"
                id="selectedMonth"
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
              />
              <label htmlFor="selectedMonth">Select Month</label>
            </div>
          </div>
        );
      case "year":
        return (
          <div className="col-md-4 me-1">
            <div className="form-floating">
              <input
                type="number"
                className="form-control"
                id="selectedYear"
                min="2000"
                max="2100"
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
              />
              <label htmlFor="selectedYear">Select Year</label>
            </div>
          </div>
        );
      case "custom":
        return (
          <>
            <div className="col-md-4 me-1">
              <div className="form-floating">
                <input
                  type="date"
                  className="form-control"
                  id="customFromDate"
                  value={customFromDate}
                  onChange={(e) => setCustomFromDate(e.target.value)}
                />
                <label htmlFor="customFromDate">From Date</label>
              </div>
            </div>
            <div className="col-md-4 me-1">
              <div className="form-floating">
                <input
                  type="date"
                  className="form-control"
                  id="customToDate"
                  value={customToDate}
                  onChange={(e) => setCustomToDate(e.target.value)}
                />
                <label htmlFor="customToDate">To Date</label>
              </div>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div className="page-content py-1">
      <NaviGate />
      <div className="card p-3 mx-2" style={{ minHeight: "80vh" }} ref={contentRef}>
        <div className="row mb-5 border-bottom justify-content-between align-items-center w-100">
          <h5 className="text-start w-auto fw-bold mb-0">
            Accounts Overview
          </h5>
          <div className="w-auto d-flex g-2 mt-0 justify-content-end align-items-center">
            <div className="col-md-4 mb-1 me-1">
              <div className="form-floating">
                <select
                  className="form-select"
                  id="filterType"
                  value={filterType}
                  onChange={(e) => setFilterType(e.target.value)}
                >
                  <option value="month">Month</option>
                  <option value="year">Year</option>
                  <option value="custom">Custom Range</option>
                </select>
                <label htmlFor="filterType">Filter By</label>
              </div>
            </div>

            {renderFilterControls()}

            <button
              type="button"
              className={"btn btn-dark ms-2 d-none"}
              onClick={() => { handlePrint(contentRef) }}
            >
              Print
            </button>
          </div>
        </div>

        <div className="row g-4 pt-4">
          <div className="col-md-12 mt-0">
            <TrialBalance
              trialData={trialData}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyReport;